import { ArrowLeftMdIcon, ChevronRightIcon } from '@forwardflow/icons'
import { Button, ContentCard, Grid, Stack } from '@forwardflow/ui-v2'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { motion } from 'framer-motion'
import { useTeamInvitation } from '@forwardflow/hooks/customHooks/onboarding'
import { OwnerAccountSelection, TeamMemberInvitation } from './team-invitation'

export const TeamInvitation = () => {
   const { getNextStep, getPreviousStep } = useOnboardingStoreV2()

   const {
      fubUser,
      invitedTeamMembers,
      editOwnerUser,
      maxTeamMembers,
      foundAccount,
      userData,
      fubOwnerUserData,
      shouldDisableInvite,
      isOnboardingCompleted,
      setFubUser,
      setEditOwnerUser,
      handleInviteUser,
      handleRemoveUser,
      handleSelectOwner,
      handleSaveAndContinue,
   } = useTeamInvitation()

   const handleNextStep = () => {
      handleSaveAndContinue()
      getNextStep()
   }

   return (
      <Stack gap={24}>
         <ContentCard
            className="space-y-2"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
         >
            <p className="text-white font-medium">
               Time to bring your team on board!
            </p>
            <p className="text-[#99A1AF] text-sm font-medium max-w-[600px]">
               Invite your team members so they can start using Forward Flow
               too.
            </p>
         </ContentCard>

         <ContentCard
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.3 }}
            className="space-y-6"
         >
            <OwnerAccountSelection
               fubUser={fubUser}
               editOwnerUser={editOwnerUser}
               foundAccount={foundAccount}
               fubOwnerUserData={fubOwnerUserData}
               isOnboardingCompleted={isOnboardingCompleted}
               onSelectOwner={handleSelectOwner}
               setEditOwnerUser={setEditOwnerUser}
               setFubUser={setFubUser}
            />

            <TeamMemberInvitation
               invitedTeamMembers={invitedTeamMembers}
               maxTeamMembers={maxTeamMembers}
               shouldDisableInvite={shouldDisableInvite}
               isOnboardingCompleted={isOnboardingCompleted}
               userData={userData}
               onInviteUser={handleInviteUser}
               onRemoveUser={handleRemoveUser}
            />
         </ContentCard>

         <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.6 }}
         >
            <Grid>
               <Grid.Col span={3}>
                  <Button
                     variant="secondary"
                     className="w-full"
                     onClick={() => getPreviousStep()}
                  >
                     <ArrowLeftMdIcon width={12} /> Back
                  </Button>
               </Grid.Col>
               <Grid.Col span={9}>
                  <Button
                     className="w-full"
                     onClick={handleNextStep}
                     disabled={!fubUser?.id}
                  >
                     {invitedTeamMembers?.length === 0 ||
                        (maxTeamMembers === 0 && 'Skip and')}{' '}
                     Save and Continue <ChevronRightIcon width={18} />
                  </Button>
               </Grid.Col>
            </Grid>
         </motion.div>
      </Stack>
   )
}
